import React from "react";
import logo from "./assets/svgs/CiphersLogoWText.svg";
import hero from "./assets/images/Dab.svg";

function Joined() {


  return (
    <center>
      <div className="w-full min-h-screen overflow-hidden bg-gradient-to-b from-success from-[400px] xl:from-[400px] via-white via-[300px] to-white">
        <a href="/">
          <img
            src={logo}
            className="fill-white w-1/3 pt-4 xl:w-[15%]"
            alt="logo"
          />
        </a>
        <div className="container pt-8 relative">
          <img
            src={hero}
            className="fill-white w-[30%] xl:w-[18%] pt-4"
            alt="logo"
          />
        </div>
        <div className="w-[346px] xl:w-full pt-8">
          <h1 className="text-[#262740]">Thanks for leaving your details!</h1>
          <p className="text-subtleText pt-4">
            We will promptly notify you upon the release of Ciphers.me
          </p>
        </div>
      </div>
    </center>
  );
}

export default Joined;
